export default __webpack_public_path__ + "static/media/auction.57b21699.svg";